import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { LocalizationService } from "src/app/service/localization/localization.service";
import { StepCode } from "./step.code";

@Component({
    templateUrl: '../../view/join/join.html'
})
export class JoinComponent {
    public joinEmail?: string;

    public stepCode: typeof StepCode = StepCode;
    public nowStepCode: StepCode = StepCode.TERMS;

    constructor(private router: Router, private localizationService: LocalizationService) {}

    public isVisible(stepCode: StepCode): boolean {
        return this.nowStepCode == stepCode;
    }

    public moveLoginPage(): void {
        this.router.navigateByUrl("");
    }

    public isKorean(): boolean {
        return this.localizationService.isKorean;
    }

    public toggleLanguage(): void {
        this.localizationService.toggleLanguage();
    }

    public cancel(): void {
        if (this.nowStepCode == StepCode.TERMS) {
            this.router.navigateByUrl("");
        } else {
            --this.nowStepCode;   
        }
    }

    public next(joinEmail?: string): void {
        if (joinEmail) {
            this.joinEmail = joinEmail;
        }

        if (this.nowStepCode == StepCode.DONE) {
            this.router.navigateByUrl("");
        } else {
            ++this.nowStepCode;
        }
    }
}